<template>
  <div>
    <v-card>
      <v-card-text>
        <h2 class="title mt-4 mb-2">Completed trade pairs last 7 days</h2>
        <Chart :chart-data="datasets" :height="200"></Chart>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Chart from "./GraphProfitTradeChart";
import pSBC from "../../plugins/pSBC";
import {roundNumber} from "../../plugins/calculation";

export default {
  components: {
    Chart
  },
  computed: {
    datasets: function() {
      let _vm = this;
      return {
        datasets: [
          {
            label: "Completed trade pairs",
            borderColor: pSBC(0.2, this.$vuetify.theme.primary),
            backgroundColor: pSBC(0.3, this.$vuetify.theme.primary),
            fill: false,
            yAxisID: "COUNT",
            data: Object.keys(this.profitTradeHistoryData).map(function(
              timestamp
            ) {
              return {
                x: timestamp,
                y: _vm.profitTradeHistoryData[timestamp].count
              };
            })
          },
          {
            label: "Trade profits (USD)",
            borderColor: pSBC(0.2, this.$vuetify.theme.warning),
            backgroundColor: pSBC(0.3, this.$vuetify.theme.warning),
            fill: false,
            yAxisID: "USD",
            data: Object.keys(this.profitTradeHistoryData).map(function(
              timestamp
            ) {
              return {
                x: timestamp,
                y: roundNumber(_vm.profitTradeHistoryData[timestamp].usd, 0)
              };
            })
          }
        ]
      };
    },
    ...mapGetters({
      profitTradeHistoryData: "accountValue/profit_trades_last_week"
    })
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/dashboard/GraphProfitTradeWrapper.vue